module.exports = __webpack_public_path__ + "img/ico2_active.8e2416a5.png";